function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13 .002A13.188 13.188 0 000 13.233a12.812 12.812 0 0013 12.77 13.196 13.196 0 0013.001-13.225 12.798 12.798 0 00-13-12.776zm-.722 6.5a.722.722 0 011.445 0v8.255a.754.754 0 11-1.51 0l.065-8.255zm.723 13.723a1.344 1.344 0 111.343-1.344 1.35 1.35 0 01-1.343 1.344z",
  fill: "#7F63FF"
});

function SvgWarningPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "9bbe51be813a1c60662b2641ea5bdbe6.svg";
export { SvgWarningPurple as ReactComponent };